import {Skeleton} from '@mantine/core';
import type {FC} from 'react';
import {cn} from '../../../../../lib/classname';

type Props = {
  className?: string;
  imageHeight?: number;
};
export const CardSkeleton: FC<Props> = ({className, imageHeight}) => {
  return (
    <div className={cn('flex flex-col', className)}>
      <Skeleton className="w-full rounded-16" height={imageHeight ?? 200} />
      <div className="flex flex-col gap-8 py-12">
        <div className="flex justify-between">
          <div>
            <Skeleton height={24} width={60} />
          </div>
          <div>
            <Skeleton height={24} width={60} />
          </div>
        </div>
        <Skeleton height={48} width="100%" />
      </div>
    </div>
  );
};
